import type { BaremetalHistoryEvent } from '@/entities/baremetal';
import type { RequestMeta, ResponseMeta } from '@/shared/api';
import request from '@/shared/api/request';

export const getBaremetalHistory = (
  id: number,
  params?: RequestMeta,
): Promise<{ history: BaremetalHistoryEvent[]; meta: ResponseMeta }> =>
  request({
    url: `/baremetals/${id}/history/`,
    params,
  });
